import { createFeatureSelector, createSelector } from '@ngrx/store';
import { getUrl } from '@cigna/core/router-state';
import {
  FANCYINVITATIONS_FEATURE_KEY,
  State,
} from './fancy-invitations.reducer';
import { conversationsQuery } from '@cigna/omni/conversations-state';
import { isChatClosed } from '@cigna/omni/chat-state';

// Lookup the 'FancyInvitations' feature state managed by NgRx
export const getFancyInvitationsState = createFeatureSelector<State>(
  FANCYINVITATIONS_FEATURE_KEY,
);

export const dismissedDMs = createSelector(
  getFancyInvitationsState,
  (state: State) => state.dismissedDms,
);

const inclusionList: string[] = ['home'];
export const isOnDashboard = createSelector(getUrl, (url) =>
  inclusionList.some((fragment) => url?.includes(fragment)),
);

export const unviewedFancyInvitationConv = createSelector(
  isChatClosed,
  isOnDashboard,
  conversationsQuery.selectFancyInvitationConvs,
  dismissedDMs,
  (chatClosed, onDashboard, initialDms, dismissed) => {
    if (onDashboard && chatClosed) {
      return initialDms.find((dm) => !dismissed?.includes(dm._id));
    }
    return undefined;
  },
);
